export const SET_USEFUL = "SET_USEFUL";
export const SET_COMMENT = "SET_COMMENT";
export const SET_RATE = "SET_RATE";
export const RESET = "RESET";
